window.addEventListener('DOMContentLoaded', () => {
  var submitButtons = document.querySelectorAll(".product-form__submit--bis");
  submitButtons.forEach(button => {
    button.addEventListener("click", openFnc);
  });

  function openFnc() {
    document.body.classList.add('scroll-lock');
    BIS.popup.toggle()

    var iframe = document.getElementById('BIS_frame');

    if (iframe) {
      var checkCloseButton = function() {
        var closeButton = iframe.contentWindow.document.querySelector('.action-close');
        if (closeButton) {
          closeButton.addEventListener('click', function() {
            document.body.classList.remove('scroll-lock');
          });
        } else {
          setTimeout(checkCloseButton, 100); // Retry after 100ms
        }
      };

      var addVariantSelected = function() {
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');

        var selectOptions = iframe.contentWindow.document.querySelectorAll("#variants option");
        if (selectOptions) {
          selectOptions.forEach(function(option) {
            if (option.value == variantId) {
              option.setAttribute('selected', true);
            } else {
              option.removeAttribute('selected');
            }
          });
        } else {
          setTimeout(addVariantSelected, 100);
        }
      }

      setTimeout(checkCloseButton, 100); // Initial check after 100ms
      setTimeout(addVariantSelected, 100);
    }
  }
});
